<template>
  <v-container fluid class="fill-height">
    <v-card class="fill-height idcs-fill-width">
      <v-card-title>
        <i18n path="title"></i18n>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="text-h5 text-center">
            <i18n path="main.welcome1" class="mr-5" />
            <i18n path="main.welcome2" />
          </v-col>
          <v-col cols="12" class="text-h6 text-center font-weight-regular"></v-col>
          <v-col cols="12">
            <v-stepper v-model="step" class="rounded-pill blue lighten-5">
              <v-stepper-header>
                <v-stepper-step complete step="1" @click="currentSlide=0" class="cursor-pointer">
                  <i18n path="main.step1" />
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="currentSlide > 3" step="2" @click="currentSlide=4" class="cursor-pointer">
                  <i18n path="main.step2" />
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="currentSlide > 10" step="3" @click="currentSlide=11" class="cursor-pointer">
                  <i18n path="main.step3" />
                </v-stepper-step>
              </v-stepper-header>
            </v-stepper>
          </v-col>
          <v-col cols="12" class="title text-center">{{imgMessage}}</v-col>
          <v-col cols="12" class="text-center">
            <v-carousel
              v-model="currentSlide"
              continuous
              :cycle="slideshow"
              hide-delimiter-background
              light
            >
              <v-carousel-item
                v-for="(item,i) in $t('main.images')"
                :key="i"
                :src="item.src"
                contain
                class="elevation-1"
              />
            </v-carousel>
          </v-col>
          <v-col cols="12">
            <v-checkbox v-model="slideshow" :label="$t('label.slideshow')"></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Main",
  data() {
    return {
      currentSlide: 0,
      slideshow: true
    };
  },
  computed: {
    imgMessage() {
      return this.$t("main.images")[this.currentSlide].txt;
    },
    step() {
      if (this.currentSlide > 3) return 2;
      if (this.currentSlide > 10) return 3;
      return 1;
    }
  },
  methods: {}
};
</script>

<style scoped>
.carusel-item-back {
  height: -webkit-fill-available;
}
.carusel-main-class {
  text-align: center;
}
.cursor-pointer :hover {
  cursor: pointer;
}
</style>